/**
 * Created by Shree on 7/27/2018.
 */
export class courses {
  constructor(
    public course_id ?: string,
    public journey_id ?: string,
    public type ?: string,
    public name ?: string,
    public description ?: string,
    public certificates : Array<any> = [],
    public games : Array<any> = [],
    public videos : Array<any> = [],
    public resources : Array<any> = [],
    public skills : Array<any> = [],
    public course_img?: string,
    public image_data?: string,
    public note ?: string,
    public total_assets ?: number,
    public is_deleted?:boolean,
    public status?: string,
    public lang?: string,
    public created_by?: string,
    public created_date ?: string,
    public updated_by?: string,
    public updated_date?: string
  ){

  }
}



// WEBPACK FOOTER //
// ./src/app/models/courses.ts